const config = require("config");

(function () {
  "use strict";
  angular
    .module("alk.companyAdmin")
    .directive("commonAccountUsers", commonAccountUsers);

  function commonAccountUsers() {
    var directive = {
      bindToController: true,
      controller: commonAccountUsersController,
      controllerAs: "vm",
      restrict: "E",
      scope: {}
    };
    directive.template = require("./commonAccountUsers.html");
    return directive;
  }

  commonAccountUsersController.$inject = [
    "$q",
    "$http",
    "UserProvider",
    "_",
    "alkModalService",
    "$translate",
    "$scope",
    "$timeout",
    "$state",
    "ssoService",
    "alkEmailService",
    "$injector",
    "mapUtilities"
  ];

  function commonAccountUsersController($q, $http, UserProvider, _, alkModalService, $translate, $scope, $timeout, $state, ssoService, alkEmailService, $injector, mapUtilities) {
    mapUtilities.attachScopeToMapEvents($scope);
    var vm = this,
      EDIT = "edit",
      NEW = "new";

    var applicationName = "";
    var addon = "";
    var Users;
    var DriverGroups;
    var VehicleGroups;
    // capitalization for support role is different depending on environment, might as well get rid of that factor
    const currentUserRoles = UserProvider.getUser().roles.map(role => role.toLowerCase());

    //FleetView will use a different API since its users must be rows in FleetUsers table beacuse they can have vehicle/driver group associations
    //So it hits the FleetLink api.
    //ContentTools just hits the regular SSO API since we don't want its users to become fleetusers
    if (process.env.ALK_APP === "fleetview") {
      applicationName = "CoPilot FleetView";
      vm.isFleetView = true;
      Users = $injector.get("Users");
      DriverGroups = $injector.get("DriverGroups");
      VehicleGroups = $injector.get("VehicleGroups");
    } else if (process.env.ALK_APP === "contenttools") {
      applicationName = "CloudXChange";
      addon = "MapSure Web Editor";
    }

    vm.displayMode = EDIT; // edit or new; This matters only if vm.listView is false.
    vm.enableCheckEmail = null;
    vm.firstName = "";
    vm.isNewUser = null;
    vm.isExistingSSOUser = null;
    vm.listView = true;
    vm.lastName = "";
    vm.tab = "vehicles";
    vm.selectedUser = null;
    vm.userEmailSearchTerm = "";
    vm.userNameSearchTerm = "";
    vm.userList = [];
    vm.sortType = "firstName";

    init();

    function init() {
      vm.isLoading = true;

      if (vm.isFleetView) {
        var promise1 = Users.getUsers(applicationName);
        var promise2 = DriverGroups.getDriverGroups();
        var promise3 = VehicleGroups.getVehicleGroups();

        $q.all([promise1, promise2, promise3]).then(function (resultsArray) {
          vm.userList = resultsArray[0];
          vm.allDriverGroups = resultsArray[1];
          vm.allVehicleGroups = resultsArray[2];
          if (currentUserRoles[0] !== "alk administrator" && currentUserRoles[0] !== "alk support") {
            initFinish();
          } else {
            vm.isLoading = false;
          }
        });

      } else {
        ssoService.getUsersInProduct().then(function (results) {
          //Convert to common format
          vm.userList = _.map(results.data, function (user) {
            var role = user.roleName;
            if (role === "Company Administrator") role = "CompanyAdmin";
            return {
              accountId: user.accountId,
              emailAddress: user.userName,
              firstName: user.firstName,
              lastName: user.lastName,
              role: role,
              roleId: user.roleId,
              userId: user.userId,
              driverGroups: [],
              vehicleGroups: []
            };
          });
          if (currentUserRoles[0] !== "alk administrator" && currentUserRoles[0] !== "alk support") initFinish();
          else {vm.isLoading = false};
        });
      }
    }

    function initFinish() {
      const validRoles = ["CompanyAdmin", "User"];
      // Support role users should be able to see others with support role
      const shouldSeeSupport = currentUserRoles.includes("support") ||
        currentUserRoles.includes("company administrator")
      if (shouldSeeSupport) {
        //TODO: look at backend for fleetview and content tools and see if different strings for Support and
        //ALK Support can be changed without too much work so both cases don't have to be accounted for
        validRoles.push("support");
        validRoles.push("Support");
      }
      vm.userList = _.filter(vm.userList, (user) => {
        if (validRoles.includes(user.role)) {
          return true;
        }
        return false;
      });
      vm.isLoading = false;
    }

    function resetForms() {
      vm.firstName = "";
      vm.lastName = "";
      vm.enableCheckEmail = null;
      vm.userExists = false;
      vm.userEmailSearchTerm = "";
      vm.selectedUser = null;
      vm.driverGroups = [];
      vm.vehicleGroups = [];
      vm.isNewUser = false;
      vm.hasChanges = false;
    }

    vm.backToListPanel = function () {
      resetForms();
      vm.listView = true;
    };

    vm.checkEmail = function () {
      var deferred = $q.defer();

      vm.userExists = false;
      var existingUser = _.find(vm.userList, function (user) {
        return user.emailAddress === vm.userEmailSearchTerm;
      });

      if (existingUser) {
        vm.enableCheckEmail = false;
        vm.userExists = true;
        return;
      }

      vm.checkEmailService().then(function (result) {
        vm.isNewUser = false;
        vm.enableCheckEmail = false;
        vm.firstName = applicationName === "CoPilot FleetView" ? result.firstName: result.data.firstName;
        vm.lastName =  applicationName === "CoPilot FleetView" ? result.lastName: result.data.lastName;
        if (applicationName === "CoPilot FleetView")
        {
          vm.vehicleGroups = result.vehicleGroups;
          vm.driverGroups = result.driverGroups;
        }

        
        vm.isExistingSSOUser = true;
      }, function (err) {
        if (err.status === 404) {
          vm.isNewUser = true;
          vm.enableCheckEmail = false;
          vm.isExistingSSOUser = false;
        }
      });
    };

    vm.checkEmailService = function () {
      var deferred = $q.defer();
      var request = {
        url: config.ssoUrl + "v1/users",
        method: "GET",
        headers: {
          "Authorization": "Bearer " + UserProvider.getUser().authToken
        },
        params: {
          email: vm.userEmailSearchTerm
        }
      };
      if (applicationName === "CloudXChange") {
        $http(request).then(function (response) {
          deferred.resolve(response);
        }, function (err) {
          deferred.reject(err);
        });
      } else {
        $http(request).then((response) => {
          Users.getUserWithGroupInfo(response.data.id).then(function (groupResponse) {
            deferred.resolve(groupResponse);
          }, function (err) {
            deferred.reject(err);

          });
        }, (err) => {
          deferred.reject(err);
        });

      }

      return deferred.promise;
    };

    vm.checkEmailDoOver = function () {
      resetForms();
    };

    vm.isLoggedInUser = function (user) {
      return user.emailAddress === UserProvider.getUser().userName;
    };

    vm.getFilteredUserList = function () {
      return _.filter(vm.userList, function (user) {
        var lowerFirstName = user.firstName == null ? "" :user.firstName.toLowerCase();
        var lowerLastName = user.lastName == null? "" :user.lastName.toLowerCase();
        var lowerSearch = vm.userNameSearchTerm.toLowerCase();
        return lowerFirstName.includes(lowerSearch) || lowerLastName.includes(lowerSearch) ||
          (lowerFirstName + " " + lowerLastName).toLowerCase().includes(lowerSearch) || user.emailAddress.toLowerCase().includes(lowerSearch);
      });
    };

    vm.cancel = function () {
      if (vm.hasChanges) {
        alkModalService.show({
          size: "sm",
        }, {
          headerText: $translate.instant("service.mapService.Unsaved Changes"),
          bodyText: $translate.instant("service.linkdrawService.You have unsaved changes."),
          closeButtonText: $translate.instant("service.mapService.Go Back"),
          actionButtonText: $translate.instant("service.mapService.Discard Changes")
        }).then(function () {
          vm.backToListPanel();
        }, function () { //Cancel

        });
      } else {
        vm.backToListPanel();
      }
    };

    vm.deleteUser = function (user) {
      alkModalService.show({
        size: "sm"
      }, {
        headerText: $translate.instant("view.accountUser.deletConfirmTitle"),
        bodyText: $translate.instant("view.accountUser.deletConfirmBody"),
        closeButtonText: $translate.instant("common.Cancel"),
        actionButtonText: $translate.instant("common.OK")
      }).then(function () { // OK
        if (vm.isFleetView) {
          Users.removeUser(user.userId, applicationName).then(function () {
            $state.reload();
          });
        } else {
          ssoService.removeUser({
            emailAddress: user.emailAddress,
            role: user.role === "CompanyAdmin" ? "Company Administrator" : user.role
          }).then(function () {
            $state.reload();
          });
        }
      }, function () { //Cancel

      });
    };

    vm.editUser = function (user) {
      vm.listView = false;
      vm.displayMode = EDIT;
      vm.selectedUser = user;
      vm.driverGroups = angular.copy(user.driverGroups);
      vm.vehicleGroups = angular.copy(user.vehicleGroups);
      vm.selectedRole = user.role;
    };

    vm.newUser = function () {
      vm.listView = false;
      vm.displayMode = NEW;
      vm.driverGroups = [];
      vm.vehicleGroups = [];
      vm.selectedRole = "User";
    };

    vm.saveExistingUser = function () {
      vm.selectedUser.role = vm.selectedRole;
      if (vm.isFleetView) {
        if (vm.selectedRole === "ALK Support") {
          vm.selectedUser.role = "ALKSupport";
        }
        Users.updateUser(vm.selectedUser, applicationName).then(function (response) {
          setGroups(vm.selectedUser.userId).then(function (response) {
            $state.reload();
          });
        });
      } else {
        var role = vm.selectedRole;
        if (role === "CompanyAdmin") {
          role = "Company Administrator";
        }
        //Create user & assign to account
        ssoService.updateExistingUser({
          accountId: UserProvider.getUser().accountId,
          emailAddress: vm.selectedUser.emailAddress,
          role: role,
          product: applicationName
        }).then(function () {
          $state.reload();
        });
      }
    };

    vm.saveNewUser = function () {
      if (vm.isFleetView) {
        var user = {
          emailAddress: vm.userEmailSearchTerm,
          firstName: vm.firstName,
          lastName: vm.lastName,
          enabled: true,
          role: vm.selectedRole
        };
        if (user.role === "ALK Support") {
          user.role = "ALKSupport";
        }
        var userId;
        Users.createUser(user, applicationName).then(function (response) {
          userId = response.userId;
          return setGroups(userId);
        }).then(function (response) {
           alkEmailService.sendRouteReporterWelcomeEmail(vm.userEmailSearchTerm,  vm.isExistingSSOUser);
          $state.reload();
        });
      } else {
        var role = vm.selectedRole;
        if (role === "CompanyAdmin") role = "Company Administrator";
        var userObj = {
          emailAddress: vm.userEmailSearchTerm,
          accountId: UserProvider.getUser().accountId,
          role: role,
          firstName: vm.firstName,
          lastName: vm.lastName
        };

        var assignUserToProduct = (vm.isNewUser) ? ssoService.createNewUser : ssoService.updateExistingUser;
        assignUserToProduct(userObj).then(response => {
          alkEmailService.sendMapsureWelcomeEmail(vm.userEmailSearchTerm, vm.isNewUser);
          $state.reload();    
        });
      }
    };

    vm.saveNewUserDisabled = function () {
      if (!vm.firstName || !vm.lastName) return true;
      return false;
    };

    function setGroups(userId) {
      if (vm.selectedRole === "CompanyAdmin") {
        return $q.when();
      }
      var vehicleGroupIds = _.map(vm.vehicleGroups, function (vehicleGroup) {
        return vehicleGroup.groupId;
      });
      var driverGroupIds = _.map(vm.driverGroups, function (driverGroup) {
        return driverGroup.groupId;
      });
      var promise1 = Users.setUserVehicleGroups(userId, applicationName, vehicleGroupIds);
      var promise2 = Users.setUserDriverGroups(userId, applicationName, driverGroupIds);
      return $q.all([promise1, promise2]);
    }

    vm.removeDriverGroup = function (driverGroup) {
       vm.hasChanges = true;
      _.remove(vm.driverGroups, {
        groupId: driverGroup.groupId
      });
    };

    vm.removeVehicleGroup = function (vehicleGroup) {
       vm.hasChanges = true;
      _.remove(vm.vehicleGroups, {
        groupId: vehicleGroup.groupId
      });
    };

    vm.getFormattedRole = function (role) {
      if (role === "User") return $translate.instant("view.accountUser.userRole");
      else if (role === "CompanyAdmin") return $translate.instant("view.accountUser.companyAdminRole");
      else if (role === "ALK Administrator") return $translate.instant("view.accountUser.alkAdminRole");
      else if (role === "ALKAdmin") return $translate.instant("view.accountUser.alkAdminRole");
      else if (["ALK Support", "ALKSupport"].includes(role)) return $translate.instant("view.accountUser.alkSupportRole");
      else if (role.toLowerCase() === "support") return $translate.instant("view.accountUser.supportRole");
      else if (role === "cloudxchange Approver") return $translate.instant("view.accountUser.approverRole");
    };

    vm.addVehicleGroup = function () {
      alkModalService.show({
        size: "md",
        template: require("./addGroups.component.html"),
        controller: "addGroupsController",
        controllerAs: "vm",
        resolve: {
          modalData: function () {
            return {
              user: vm.selectedUser,
              selectedVehicleGroups: vm.vehicleGroups,
              selectedDriverGroups: vm.driverGroups,
              allVehicleGroups: vm.allVehicleGroups,
              allDriverGroups: vm.allDriverGroups,
              isVehicle: true
            };
          }
        }
      }).then(function (results) {
        vm.hasChanges = true;
        vm.vehicleGroups = results.groups;
      }, function () { //new
      });
    };

    vm.addDriverGroup = function () {
      alkModalService.show({
        size: "md",
        template: require("./addGroups.component.html"),
        controller: "addGroupsController",
        controllerAs: "vm",
        resolve: {
          modalData: function () {
            return {
              user: vm.selectedUser,
              selectedVehicleGroups: vm.vehicleGroups,
              selectedDriverGroups: vm.driverGroups,
              allVehicleGroups: vm.allVehicleGroups,
              allDriverGroups: vm.allDriverGroups,
              isVehicle: false
            };
          }
        }
      }).then(function (results) {
        vm.hasChanges = true;
        vm.driverGroups = results.groups;
      }, function () { //new
      });
    };

    vm.testAddVehicleGroup = function () {
      vm.hasChanges = true;
      var newGroup = vm.allVehicleGroups[vm.vehicleGroups.length];
      var group = {
        groupId: newGroup.id,
        groupName: newGroup.name,
        numMembers: newGroup.numberOfVehicles
      };
      vm.vehicleGroups.push(group);
    };

    vm.testAddDriverGroup = function () {
      vm.hasChanges = true;
      var newGroup = vm.allDriverGroups[vm.driverGroups.length];
      var group = {
        groupId: newGroup.id,
        groupName: newGroup.name,
        numMembers: newGroup.numberOfDrivers
      };
      vm.driverGroups.push(group);
    };

    vm.showSupportRoleOption = () => {
      return currentUserRoles.includes("support") || currentUserRoles.includes("alk support");
    }

    vm.showAlkSupportRoleOption = () => {
      return currentUserRoles.includes("alk support");
    }

  }

})();


// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-company-admin/commonAccountUsers.directive.js